import GenerateQuotation from "./generate-quotation.container";

export default GenerateQuotation;
